import script from "./LoRedirect.vue?vue&type=script&setup=true&lang=js"
export * from "./LoRedirect.vue?vue&type=script&setup=true&lang=js"

import "./LoRedirect.vue?vue&type=style&index=0&id=43906da5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43906da5"]])

export default __exports__